export const ProfilePermissionTypes = {
  FULL_ACCESS: "full-access",
  NO_ACCESS: "no-access",
  READ_ONLY: "read-only",
  USER_VERIFICATION_NOT_SUBMITTED: "user-verification-not-submitted",
  USER_VERIFICATION_PENDING: "user-verification-pending",
  INVESTOR_VERIFICATION_NOT_SUBMITTED: "investor-verification-not-submitted",
  RESTRICTED: "restricted",
} as const;
export type ProfilePermissionType =
  (typeof ProfilePermissionTypes)[keyof typeof ProfilePermissionTypes];

export class ProfileSectionConfig {
  permission!: ProfilePermissionType;
  canDelete?: boolean;
}

export class ProfileConfig {
  information!: ProfileSectionConfig;
  authorizedMembers!: ProfileSectionConfig;
  investmentProfile!: ProfileSectionConfig;
  taxCenter!: ProfileSectionConfig;
  documentCenter!: ProfileSectionConfig;
  settings!: ProfileSectionConfig;
  documents!: ProfileSectionConfig;
  keyParties!: ProfileSectionConfig;
  // other sections in the future
}

export class ProfileConfigDto {
  profile!: ProfileConfig;
}
